export const couponType = [
  { id: 'Eventi', name: 'Eventi', title: 'event' },
  { id: 'Corsi', name: 'Corsi', title: 'course' },
  { id: 'Tutto il sito', name: 'Tutto il sito', title: 'all' },
];

export const getStatusTitle = (id: string) => {
  return couponType.find((type) => type.id === id)?.name;
};
